import { ActionCard } from '../components/ActionCard/ActionCard';
import { HistoryTable } from '../components/HistoryTable/HistoryTable';
import { HomeCalendar } from '../components/HomeCalendar/HomeCalendar';
import { HomeCarousel } from '../components/HomeCarousel/HomeCarousel';
import { PlanningCard } from '../components/PlanningCard/PlanningCard';
import { PlanUpgradeCard } from '../components/PlanUpgradeCard/PlanUpgradeCard';
import type { HomeData } from '../types/home.types';
import styles from './HomePage.module.css';

interface HomePageProps {
	data: HomeData;
	onNavigate?: (link: string) => void;
}

export const HomePage = ({ data, onNavigate }: HomePageProps) => {
	const handleNavigation = (link: string) => {
		if (onNavigate) {
			onNavigate(link);
		}
	};

	return (
		<div className={styles.homeContainer}>
			<div className={styles.mainContent}>
				<div className={styles.topSection}>
					<div className={styles.carouselSection}>
						<HomeCarousel slides={data.carousel} onSlideClick={handleNavigation} />
					</div>

					<div className={styles.actionCardsSection}>
						{data.actionCards.map((card) => (
							<ActionCard key={card.id} data={card} onClick={handleNavigation} />
						))}
					</div>
				</div>

				<section className={styles.historySection}>
					<HistoryTable />
				</section>
			</div>

			<aside className={styles.sidebar}>
				<div className={styles.calendarWrapper}>
					<div className={styles.calendarSection}>
						<HomeCalendar
							currentMonth={data.calendar.currentMonth}
							currentYear={data.calendar.currentYear}
							events={data.calendar.events}
							selectedPeriod={data.calendar.selectedPeriod}
						/>
					</div>
					<div className={styles.planningSection}>
						<PlanningCard events={data.calendar.events} />
					</div>
				</div>

				<div className={styles.planCardWrapper}>
					<PlanUpgradeCard
						planInfo={data.planInfo}
						onUpgradeClick={() => handleNavigation('/checkout/plano?upgrade=1')}
					/>
				</div>
			</aside>
		</div>
	);
};
